module.exports = __webpack_public_path__ + "static/scale-model-of-uss-torsk-in-baltimore-maryland-ea05b0bf106a7394080720acdc481eeb.png";